// Translation: Account > Integrations > Access keys > Access key deletion dialog (Turkish)
export default Object.freeze({
	actions: {
		cancel: 'İptal',
		delete: 'Sil'
	},
	message: {
		text: 'Bu erişim anahtarını silmek istediğinize emin misiniz?',
		title: 'Erişim anahtarı silinecek'
	}
})
